import { render, staticRenderFns } from "./DepotTab.vue?vue&type=template&id=3f160733&scoped=true"
import script from "./DepotTab.vue?vue&type=script&lang=js"
export * from "./DepotTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f160733",
  null
  
)

export default component.exports